<script>
	import UserStore from './stores/user';
	import Router from 'svelte-spa-router'
	import mainRoutes from './routes.js'	
	import { addMessages, init , locale } from "svelte-i18n";
	import { push } from 'svelte-spa-router';	
	
	let routes;

	//console.log('test',localStorage.getItem('user'))


	if (localStorage.getItem('user') ===null || localStorage.getItem('user')=='' || localStorage.getItem('user')=='{}') {
		localStorage.setItem('user', '{}');
		push('/login');
	} else {
		let saved_platforms = localStorage.getItem('platforms');
		if (saved_platforms!=null && typeof saved_platforms!=='undefined') {
			platforms = JSON.parse(localStorage.getItem('platforms'));
		}
		console.log(platforms)
		let user = JSON.parse(localStorage.getItem('user'));
		UserStore.set(user)
	}

	


	import en from "./locales/en.json";
	import he from "./locales/he.json";

	addMessages("en", en);
	addMessages("he", he);

	init({
		initialLocale: "he",
	});	

	routes = mainRoutes;

	
	
	
	if (!$UserStore.settings 
			|| !$UserStore.settings.shipping_settings 
			|| !$UserStore.settings.shipping_settings.shipping_method ) 
	{
		push('/settings');
	}

	if (typeof pushPage !== 'undefined' && pushPage!='') {

		push('/'+pushPage);

	}

</script>

<main>
	<Router {routes}/>
</main>
